// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"2fc459c54334805686c1","303":"710cb50f92a1ec1e311f","495":"57a4620cddfeb50e8402"}[chunkId] + ".js";
};